import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TelerecourspnrSharedModule } from '../shared';

import { RattachementService } from './rattachement.service';
import { RATTACHEMENT_ROUTE } from './rattachement.route';
import { RejoindreDossierComponent } from './steps/rejoindre-dossier/rejoindre-dossier.component';
import { RattachementComponent } from './rattachement.component';
import { AvertissementsComponent } from './steps/avertissements/avertissements.component';
import { ConfirmationComponent } from './steps/confirmation/confirmation.component';

@NgModule({
    imports: [
        TelerecourspnrSharedModule,
        RouterModule.forRoot([RATTACHEMENT_ROUTE], { useHash: true })
    ],
    declarations: [
        AvertissementsComponent,
        RejoindreDossierComponent,
        ConfirmationComponent,
        RattachementComponent
    ],
    providers: [
        RattachementService
    ],
})
export class TelerecourspnrRattachementModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/rattachement/rattachement.module.ts